<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="350" persistent>
      <v-card>
        <v-card-title
          class="headline body-1 blue-grey darken-1 lighten-1 white--text font-weight-thin"
          primary-title
        >
          <v-icon class="white--text mr-2">mdi-wallet</v-icon>Conta Kyami
        </v-card-title>
        <v-card-text class="pa-6">
          <v-fade-transition mode="out-in">
            <v-card-text class="color-wallet" fill-dot rigth>
              <span
                id="copyText"
                style="color: #FFFFFF; font-size: 14px"
                class="mt-2 m-display-block"
                >{{ getBanckAccount }}</span
              >
            </v-card-text>
          </v-fade-transition>
        </v-card-text>
        <v-card-text class="text-center">
          <v-btn fab dark small color="blue-grey" @click="copyBank">
            <v-icon>mdi-content-copy</v-icon>
          </v-btn>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-grey" text @click="dialog = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import eventBus from "../../main";
import { mapHelper } from "../../store/helper";

export default {
  name: "BankAccount",
  data: () => ({
    dialog: false
  }),
  methods: {
    copyBank() {
      if (navigator.clipboard.writeText(this.$store.getters.getBanckAccount))
        return eventBus.$emit("openInfo", {
          color: "warning",
          text: "Conta copiada",
          errorLogin: true,
          right: "center",
          top: "bottom"
        });
    }
  },
  computed: {
    ...mapHelper
  },
  created() {
    const self = this;
    eventBus.$on("openBankAccounts", function(value) {
      self.dialog = value;
    });
  }
};
</script>
<style scoped>
.color-wallet {
  min-height: 80px;
  background-color: #26a69a;
  text-align: center;
  padding-top: 20px;
  display: block;
  font-size: 18px;
}
</style>
